import { parseJwt } from 'utils/jwt';

const useUser = () => {
  const { sub, firstName, lastName } = parseJwt(localStorage.getItem('token'));
  return { id: sub, fullName: `${firstName} ${lastName}` };
};

export default useUser;
